export default __webpack_public_path__ + "5f7a8b3472d0a5c5635c623baca575fb.svg";